import React from 'react';
// @ts-ignore
import {
    Modal,
    ModalBody,
    ModalContent,
    ModalDialog,
    ModalHeader,
} from 'arag-ui-lib';
import { useTranslation } from 'react-i18next';
type Props = {
    openDocumentModal: boolean;
    onCloseDocumentModal: () => void;
    claimApplicationTemplate: any;
};

const DisplayDocumentClickedByEmailLink = (props: Props) => {
    const {
        openDocumentModal,
        onCloseDocumentModal,
        claimApplicationTemplate,
    } = props;
    const { t } = useTranslation();

    return (
        <Modal
            id={'display_document_modal'}
            fadeIn={openDocumentModal}
            darkenedBackground
            noScroll={true}
        >
            <ModalDialog id={'display_document_dialog'} size={'lg'}>
                <ModalContent id={'display_document_content'}>
                    <ModalHeader
                        id={'display_document_header'}
                        title={''}
                        onClose={() => onCloseDocumentModal()}
                    />
                    <ModalBody id={'display_document_wrapper'}>
                        {claimApplicationTemplate &&
                        claimApplicationTemplate.content ? (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: claimApplicationTemplate.content,
                                }}
                            />
                        ) : (
                            // @ts-ignore
                            <div>
                                <p> {t<string>('recordsNotExist')}</p>
                            </div>
                        )}
                    </ModalBody>
                </ModalContent>
            </ModalDialog>
        </Modal>
    );
};

export default DisplayDocumentClickedByEmailLink;
